<template>
    <div>
        <div class="container">
            <div class="row">
                 <TitleArea title="Marrëdhënia me Publikun" />
                 <!-- Lajmet ketu poshte: -->

            </div>
        </div>
    </div>
</template>
<script>
import TitleArea from '@/components/share/TitleArea.vue';

export default {
  components: { TitleArea },
    data(){
        return{

        }
    },
    componnta:{
        TitleArea
    }
}
</script>
<style lang="">
    
</style>